import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Cards from "components/MyActivityComponents/Cards";
import { useGetAllSubscriptionsQuery } from 'api/subscription';

function Alltypes() {

  const [Orders, setOrders] = useState([])

  let user = localStorage.getItem("user")
  user = JSON.parse(user)
  console.log("user", user)
  console.log("userid", user?.profile?._id)
  const { data: AllSubs, isLoading } = useGetAllSubscriptionsQuery(user?.profile?._id);
  // console.log(data)
  console.log(AllSubs)

  useEffect(() => {
    const tmpData = [];
    if (AllSubs && AllSubs.data)
      AllSubs.data.map((item, index) => {
        console.log(item?.user, user?.profile?._id)
        if (item?.user == user?.profile?._id) {
          tmpData.push({ ...item, id: ++index });
        }

      });
    // console.log("tmpData", tmpData)
    setOrders(tmpData);

  }, [AllSubs])


  return (
    <>

      <Box sx={{}}>

        {
          Orders && Orders.length > 0 ? (
            <>
              {Orders &&
                Orders?.map((item) => {
                  // let orderTemp = {
                  //   img: "https://picsum.photos/200",
                  //   label: "Personal subscription",
                  //   heading: "Baked Fish Fillets with Cheese Sauce",
                  //   address: "Chef Juna Food, 4474 Bridge",
                  //   date: "12 Oct -12 Nov 2021",
                  //   chipColor: "#7B49E5",
                  // };
                  // if (item) {
                  //   orderTemp.date = `${new Date(
                  //     item.deliveryDetails[0].subscriptionId.from
                  //   ).toDateString()} - ${new Date(
                  //     item.deliveryDetails[0].subscriptionId.to
                  //   ).toDateString()} `;
                  //   orderTemp.address = item.deliveryDetails[0].deliveryTo.address;
                  //   orderTemp.label = item.deliveryDetails[0].subscriptionId.type;
                  // }
                  return (
                    <Cards
                      // data={orderTemp}
                      data={item}
                      id={item?._id}
                      // handleChange={(e) => {
                      //   console.log("eee", e);
                      // }}
                      hasActionButton={true}
                    />
                  );
                })}
            </>
          ) : (
            <>

            </>
          )
        }
      </Box>

    </>
  )
}

export default Alltypes